/**
 * dir-w | backOffice
 * Shared component for pagination collections
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IBasePagination } from '../../interfaces/pagination.interface';
import { enumPagination } from '../../app.enum';
import { Configuration } from '../../config/configuration';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.css',
    standalone: false
})
export class PaginationComponent {
  @Input() pagination: IBasePagination = JSON.parse('{}');
  @Input() listParams: Array<{ key: string; value: string }> = [];
  @Output() pagingEvent = new EventEmitter<
    Array<{ key: string; value: string }>
  >();

  protected navigateTo = enumPagination;

  paginationClick(_destination: enumPagination): void {
    switch (_destination) {
      case enumPagination.FIRST: {
        this.listParams.map((item) =>
          item.key === 'page' ? (item.value = '1') : item
        );
        break;
      }
      case enumPagination.LAST: {
        this.listParams.map((item) =>
          item.key === 'page'
            ? (item.value = this.pagination.last_page.toString())
            : item
        );
        break;
      }
      case enumPagination.PREVIOUS: {
        if (this.pagination.current_page == 1) return;
        this.listParams.map((item) =>
          item.key === 'page'
            ? (item.value = (this.pagination.current_page - 1).toString())
            : item
        );
        break;
      }
      default: {
        if (this.pagination.current_page == this.pagination.last_page) return;
        this.listParams.map((item) =>
          item.key === 'page'
            ? (item.value = (this.pagination.current_page + 1).toString())
            : item
        );
        break;
      }
    }
    this.listParams.map((item) =>
      item.key === 'size' ? Configuration.pageSize.toString() : item
    );

    // send the result to collection page
    this.pagingEvent.emit(this.listParams);
  }
}
